import Popover from "@mui/material/Popover";
import { PDropdown } from "./PDropdown";

// THE "SORT BY" `p-confirmPopup` THE IN PLAY AND PLAYERS PAGES OPEN FROM THEIR SORT
// BUTTON: 1PX `rgba(0,0,0,.2)` BORDER, 4PX RADIUS, NO ARROW (`_overrides.scss`), 1.25REM
// CONTENT PADDING; A BOLD "SORT BY:" LABEL OVER A `mt-1 w-full` DROPDOWN. PICKING AN
// OPTION APPLIES IT AND CLOSES THE POPUP.
export function SortByPopup<V extends string>(props: {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  value: V;
  options: Array<{ label: string; value: V }>;
  onChange: (v: V) => void;
}) {
  const { anchorEl, onClose, value, options, onChange } = props;
  return (
    <Popover
      open={anchorEl !== null}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      slotProps={{ paper: { sx: { mt: "0.75rem", border: "1px solid rgba(0, 0, 0, 0.2)", borderRadius: "4px", minWidth: 240 } } }}
    >
      <div style={{ padding: "1.25rem" }}>
        <div className="flex flex-column w-full">
          <label className="font-bold">Sort By:</label>
          <PDropdown
            className="mt-1 w-full"
            value={value}
            options={options}
            placeholder="Select Sort By"
            onChange={(v) => {
              onChange(v);
              onClose();
            }}
          />
        </div>
      </div>
    </Popover>
  );
}
